import CheckboxField from "./Checkbox.jsx";
import RadioField from "./Radio.jsx";

export default {
  Radio: RadioField,
  Checkbox: CheckboxField,
};
